<template lang="pug">
  vm-prompt(@vm-cancel="close" vm-size="large" @vm-accept="close" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="close" :vm-is-valid="props" :vm-active="isModalAddPaymentOCVisible" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w="12" class="form__wrapper")
      vm-col(vm-justify="center", vm-align="center", vm-w=2)
        b-form-group
          vm-input(:placeholder='$t("strings.add_amount")' :label='$t("strings.amount")' v-model="payment.amount" @keypress="validarValor()"  @keyup="validarValor()")
      vm-col(vm-justify="center", vm-align="center", vm-w=3)
        vm-select(column="method" :placeholder='$t("payment_methods.add")' :label='$t("strings.payment_method")' v-model="payment.way_to_pay"  @change="type_method")
          vm-select-item(:key="index" :value="item.type" :text="item.type" v-for="(item,index) in methods")
      vm-col(vm-justify="center", vm-align="center", vm-w=2)
        b-form-group
          vm-input(:placeholder='$t("sales.digits_card_placeholder")' :label='$t("sales.digits_card")' v-model="payment.digits" v-if="visible")
      vm-col(vm-justify="center", vm-align="center", vm-w=3)
        b-form-group
          vm-date-picker(:placeholder='$t("strings.select_date")' type="date" :label='$t("strings.payment_date")' @on-change="handleChange" :value="paymentDate" style="width=100%;" v-model="datepicker")
      vm-row.row-quantity(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w="12")
        vm-col(vm-justify="center", vm-align="center", vm-w=3)
          b-form-group.general-information
            h2.amount Monto total de la orden
            h2 {{ amount_order | currency}}
        vm-col(vm-justify="center", vm-align="center", vm-w=4)
          b-form-group.general-information
            h2.amount Monto total abonado
            h2 {{ amount | currency }}
        vm-col(vm-justify="center", vm-align="center", vm-w=4)
          b-form-group.general-information
            h2.amount Monto restante
            h2 {{ resto | currency }}
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.payments') }}:
            span {{ $t('strings.description', {attribute: $t('strings.payments')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-button(icon="checkmark-circle-2-outline" @click="saveRecord" :disabled="actived") {{ $t('strings.save') }}
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(v-model="selected"  max-height="350px" :data="payments" class="table")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('strings.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column == 'amount'")  {{data[indextr][column] | currency}}
                  slot(v-if="column == 'method'")  {{data[indextr]['way_to_pay']}}
                  slot(v-if="column == 'digits_card'")  {{data[indextr]['digits']}}
                  slot(v-if="column == 'date'")  {{data[indextr][column] | moment("DD MMMM YYYY")}}
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="flat" icon="more-horizotnal" color="#AFBBC6")
                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="deletePaymentsOCConfirm(data[indextr])")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
                    //- More actions
          vm-pagination(:total="paginationPayments.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}

</template>

<script>
import { required, numeric, minLength, maxLength } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')

export default {
  name: 'ModalAddPaymentOC',
  props: {
    payment: {
      type: Object,
      default: () => {}
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    form: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    currentPage: 1,
    datepicker: '',
    visible: false,
    actived: true,
    columns: [
      'amount',
      'method',
      'digits_card',
      'date'
    ],
    paymentDate: '',
    methods: [
      {
        id: 1,
        type: 'Efectivo'
      },
      {
        id: 2,
        type: 'Credito'
      },
      {
        id: 3,
        type: 'Transferencia'
      },
      {
        id: 4,
        type: 'Tarjeta'
      },
      {
        id: 5,
        type: 'Stock'
      }
    ]
  }),
  validations () {
    return {
      payment: {
        amount: {
          required,
          numeric,
          minLength: minLength(3),
          maxLength: maxLength(4)
        },
        method: {
          required
        },
        date: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalAddPaymentOCVisible',
      'payments',
      'paginationPayments',
      'amount',
      'amount_order'
    ]),
    resto () {
      return this.amount_order - this.amount
    },
    payment_date () {
      return `?payment_date=${this.paymentDate}`
    },
    title () {
      return this.isAdd ? this.$t('strings.addpayments') : this.$t('payment.edit')
    }
  },
  watch: {
    isModalAddPaymentOCVisible (flag) {
      if (flag) {
        this.loadAmount({ id: this.payment.purchase_order_id })
        this.loadPayments({ page: this.currentPage, purshase_order_id: this.payment.purchase_order_id })
      }
    },
    currentPage (currentPage) {
      this.loadPayments({ page: this.currentPage, purshase_order_id: this.payment.purchase_order_id })
    }
  },
  methods: {
    ...mapActions([
      'printReportRecord',
      'setModalAddPaymentOCVisible',
      'addPaymentOC',
      'loadPayments',
      'deletePaymentsOC',
      'loadAmount'
    ]),
    editPaymentOC (payment, index) {
      this.isAdd = false
      this.payment = payment
      this.datepicker = this.payment.date
    },
    async deletePaymentsOCConfirm (payment) {
      let t = this
      this.auxDeletePaymentOC = () => {
        t.deletePaymentsOC(payment)
        this.loadAmount({ id: this.payment.purchase_order_id })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.payments'), attribute: payment.id }),
        accept: this.auxDeletePaymentOC
      })
    },
    type_method  () {
      const type = this.payment.way_to_pay
      if (type === 'Tarjeta') {
        this.visible = true
      } else {
        this.visible = false
      }
    },
    validarValor () {
      if (parseFloat(this.payment.amount) <= parseFloat(this.resto) && parseFloat(this.payment.amount) !== null && parseFloat(this.payment.amount) > 0) {
        this.actived = false
      } else if (parseFloat(this.payment.amount) > parseFloat(this.resto) || parseFloat(this.payment.amount) !== null || parseFloat(this.payment.amount) === 0) {
        this.actived = true
      }
    },
    close () {
      this.setModalAddPaymentOCVisible(false)
    },
    async saveRecord () {
      const d = new Date(this.datepicker)
      const dformat = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join('-')
      this.payment.date = dformat
      await this.addPaymentOC(this.payment)
      this.actived = true
      this.payment = {
        purchase_order_id: this.payment.purchase_order_id
      }
      this.datepicker = ''
      await this.loadAmount({ id: this.payment.purchase_order_id })
    },
    handleChange (date) {
      this.paymentDate = date
    }
  }
}
</script>

<style lang="scss">
.row-quantity {
  padding: 30px;
}
.general-information {
  text-align: center;
}
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}

.form__wrapper {
  margin-bottom: 20px;
}

.amount__wrapper {
  padding: 10px 0;
}

.amount {
  font-weight: bold;
  text-align: center;
}

.form-group {
  margin-bottom: 0px !important;
}

.table {
  .td {
    span {
      display: block !important;
      text-align: center !important;
    }
  }
}
</style>
